export default {
  title: 'Parking Payment',
  // check-in kiosk
  check_in_title: 'Parking Check-in',
  check_in_subtitle: 'Enter your plate to check in. A photo is optional.',
  license_plate_label: 'License plate',
  license_plate_placeholder: 'e.g. 1กก 1234',
  photo_label: 'Vehicle photo (optional)',
  tap_to_capture: 'Tap to take a photo',
  retake_photo: 'Retake',
  check_in_submit: 'Check in',
  checking_in: 'Checking in…',
  // pay page
  checked_in_at: 'Checked in at {{time}}',
  checked_in_subtitle: 'When you are ready to leave, tap below to pay.',
  pay_now: "I'm leaving, pay now",
  preparing_payment: 'Preparing your payment…',
  tap_to_refresh: 'Tap to check status',
  scan_qr_to_pay: 'Scan to pay',
  scan_dynamic_qr: 'Scan to pay with PromptPay',
  reference_label: 'Reference',
  charge_amount: 'Amount: ฿{{amount}}',
  upload_slip: 'Upload payment slip',
  upload_slip_locked: 'Upload slip (take a photo of your car first)',
  remove_slip: 'Remove slip image',
  tap_to_upload: 'Tap to select slip image',
  submit_slip: 'Submit Slip',
  slip_submitted: 'Slip submitted',
  waiting_title: 'Slip submitted',
  waiting_subtitle: 'Checking your slip. This page updates automatically.',
  upload_new_slip: 'Upload a new slip',
  paid_title: 'Payment Verified',
  paid_subtitle: 'Verified at {{time}}. Drive safely!',
  // EP-161 S3a: the live car photo before the slip
  car_photo: {
    step_title: 'Take a photo of your car showing the plate and where it is parked',
    open_camera: 'Open camera',
    camera_title: 'Photo of your car',
    hint: 'Show the plate and where it is parked',
    asking: 'Opening the camera',
    shutter: 'Take',
    retake: 'Retake',
    captured_alt: 'Photo of your car',
    uploading: 'Sending the car photo',
    refused_title: 'Allow the camera to take a photo of your car',
    refused_iphone: 'iPhone: tap aA in the address bar, choose Website Settings, then set Camera to Allow',
    refused_android: 'Android: tap the icon before the web address, choose Permissions, then allow Camera',
    retry: 'Try the camera again',
  },
  // EP-161 S3: rejected slip
  rejected_title: 'Slip not accepted',
  rejected_reason: 'Reason: {{reason}}',
  rejected_plate: 'Plate {{plate}}',
  rejected_resubmit: 'Send a new slip',
  rejected_contact_staff: 'Or contact staff at the guard booth',
  // EP-161 §10 item 17: slip_upload answered contact_staff
  contact_staff_title: 'Please contact the staff at the guard booth',
  contact_staff_subtitle: 'A staff member will help you pay for your parking.',
  overstay_title: 'Please contact staff to check out',
  overstay_subtitle: 'Your vehicle has been parked past the automatic payment window. A staff member will help you pay.',
  errors: {
    invalid_token: 'Invalid or expired payment link.',
    invalid_apikey: 'This check-in link is invalid or has expired.',
    load_failed: 'Failed to load session. Please try again.',
    upload_failed: 'Upload failed. Please try again.',
    checkout_failed: 'Could not start payment. Please try again.',
    no_file: 'Please select an image.',
    no_plate: 'Please enter your license plate.',
    check_in_failed: 'Check-in failed. Please try again.',
    location_photo_stale: 'This photo is too old. Please take a new one.',
    location_photo_required: 'Take a photo of your car before sending the slip.',
    capture_failed: 'Could not take the photo. Please try again.',
  },
}
